const APIHOST = "http://xinadmin.meiqiuapp.com/api";
const TOKEN = "9517ca532a3e7ae34f401e4697b66ecc";
const WSSURL = "wss://admin.yuyuyoudao.cn:9453"
var BASEURL = {

	getFooterData: '/index/bottom-common', //获取首页底部数据
	getnbList:'/web/get-webxinmeizhuliu', //获取首页轮播数据
	register:'/web/zhuce'  ,  //注册用户
	sendCode:'/web/get-sms-code' , //发送验证码
	login:'/web/denglu-pwd' , //密码登录
	loginSms:'/web/denglu-sms',  //验证码登录
	forgetPassword:'/web/update-password', //忘记密码
	meizhongfenlei:'/web/getxinmeiclass',  //获取煤种分类
    getdonglimei:'/web/getdongli', //获取动力煤列表
	getlianjiao:'/web/getlianjiao', //获取炼焦煤列表
	getwuyan:'/web/getpenchui', //获取无烟煤列表
	getshaojie:'/web/getshaojie', //获取烧结煤列表
	gethuagong:'/web/gethuagong', //获取化工煤列表
	getminyong:'/web/getminyong', //获取民用煤列表
	getjiaotan:'/web/getjiaotan', //获取焦炭列表
	getlantan:'/web/getlantan', //获取兰炭列表
	getzhuliu:'/web/get-webxinmeizhuliu', //获取NB指数
	userinfo:'/web/get-userinfo', //获取用户信息
	updateinfo:'/web/edit-userinfo', //修改用户信息
	getoldphone:'/web/check-sms-code', //修改手机号--本机验证码
	updatephone:'/web/update-phone', //修改手机号--更新手机号
	getxinqiyun:'/web/get-xinqiyun', //获取出发地目的地运费数据
	getxinqiyunmudidi:'/web/get-xinqiyunmudidi', //汽运目的地
	getxinmeiqiyunclass:'/web/get-xinmeiqiyunclass', //获取省市区县数据
	gethezuohuoban:'/web/get-hezuohuoban', //获取合作伙伴
	getvipprice:'/web/getvipprice', //获取会员价格
	buyvip2:'/web/buyvip2', //提供的二维码
	getorderstatus:'/web/getorderstatus', //获取订单状态
	getvipquanyi:'/web/get-vipquanyi', //获取会员权益
	getmembervip:'/web/getmembervip', //获取会员信息
	getdanye:'/web/get-danye', //获取单页
};

const config = {
	APIHOST: APIHOST,
	TOKEN: TOKEN,
	BASEURL: BASEURL,
	WSSURL: WSSURL
};

export default config;